export default "__VITE_ASSET__COliZGgd__"